module.exports = {"10x10": __webpack_public_path__ + "images/satellite-debris-tiny-2-10x10.png"};